import React from "react"
import "../index.css"
import car from "../assets/car.svg"
import wa from "../assets/wa.png"
import Mailto from "react-protected-mailto/dist/obfuscate";

const HomePage = () => {
    return <div className={"p-20 text-white space-y-20"}>
        <div className={
            "text-2xl bg-black border border-yellow-600 " +
            "sm:text-4xl " +
            "lg:flex lg:text-4xl"
        }>
            <div className={"lg:w-1/3"}> Такси Борис </div>
            <div className={"lg:w-1/3"} >
                <a href="tel:0507136557">0507136557</a>
            </div>
            <div className={"lg:w-1/3"}>
                <Mailto  email='bohas83@gmail.com'/>
            </div>

        </div>
        <div className={"flex"}>
                <img className={"m-auto"} src={car} alt={"car"}></img>
        </div>
        <div className={
            "text-3xl space-y-20 " +
            "sm:text-2xl sm:space-y-20 " +
            "lg:flex lg:space-x-10 lg:space-y-0 lg:text-3xl"
        }>
            <div className={"bg-black border border-yellow-600 p-1 lg:w-1/3"}>
                נהג אחראי ומנוסה מציע הסעות וטיולים בכל רחבי הארץ🚖.
                מובטחת חווית נסיעה על רכב חדש ונוח עם מקום ל6 אנשים.
                (טבריה🏖, ירושלים🕍, ים המלח🏝, אילת 🏜וכל נקודה אחרת בארץ)
                יציאה מכל נקודה שתבחרו 24/7.
                הסעות לנתבג🛫 ואיסוף מנתבג🛬.
                בנוסף אפשר לסגור הסעת עובדים למקום עבודה עד 6 אנשים🚐
                לפרטים 📞<a href="tel:0507136557">0507136557</a>
            </div>
            <div className={"bg-black border border-yellow-600 p-1 lg:w-1/3"}>
                Опытный и ответственный

                водитель из Ашкелона предлагает
                междугородние поездки по

                всей стране ‚ экскурсии на

                новом комфортабельном такси
                Мерседес Вито до *6*пассажиров
                (Тверия,Ирусалим, Мёртвое море,
                Эйлат и др.), выезд из любой
                точки страны 24/7.

                Трансфер в аэропорт и
                обратно(встречу в аэропорту)
                Также возможно сотрудничество
                с фирмами по подвозке, развозке
                рабочих ( 6 чел.)

                Тел. <a href="tel:0507136557">0507136557</a>
            </div>
            <div className={"bg-black border border-yellow-600 p-1 lg:w-1/3"}>
                An experienced and responsible driver from Ashkelon offers long-distance trips throughout the country
                ‚excursions in a new comfortable Mercedes Vito taxi up to * 6 * passengers (Tiberias, Jerusalem, Dead
                Sea, Eilat, etc.), departure from anywhere in the country 24/7. Transfer to the airport and back
                (meeting at the airport) It is also possible to cooperate with companies for transportation,
                transportation of workers (6 people) Tel. <a href="tel:0507136557">0507136557</a>
            </div>
        </div>
        <div className={"flex justify-center space-x-6"}>
            {/*<a href="tel:0507136557">0507136557</a>*/}
            <a href="https://wa.me/+9720507136557"><img className={"w-7"} src={wa}/></a>

        </div>
    </div>
};
export default HomePage;
